import { PushTutos } from '@components/push-tutos/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const pushTutosMock: Block<PushTutos> = {
  type: 'push-tutos',
  data: {
    title: { text: 'Encore plus de [[tutos]]', as: 'h2' },
    tutos: [
      {
        image: imageMock,
        url: '/mock-tutos/installation-facades-tiroirs-coulissants',
        title: `J'installe les facades des tiroires et coulissants en vidéo`,
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec gravida nibh. Vestibulum ullamcorper quam neque, vel vestibulum purus ornare in. Phasellus fringilla justo eleifend est cursus, sit amet rhoncus lorem imperdiet. Vestibulum eu ex nec lorem convallis placerat. Etiam nibh turpis, elementum cursus massa non, posuere iaculis odio. Aenean id bibendum nunc. Nunc sed consequat lacus. Proin rhoncus nulla magna, id luctus mi egestas vitae. Nunc facilisis hendrerit condimentum. Sed sit amet gravida sem.',
      },
      {
        image: imageMock,
        url: '/mock-tutos/pose-meuble-angle',
        title: 'Je pose un meuble d’angle en vidéo',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec gravida nibh. Vestibulum ullamcorper quam neque, vel vestibulum purus ornare in. Phasellus fringilla justo eleifend est cursus, sit amet rhoncus lorem imperdiet. Vestibulum eu ex nec lorem convallis placerat. Etiam nibh turpis, elementum cursus massa non, posuere iaculis odio. Aenean id bibendum nunc. Nunc sed consequat lacus. Proin rhoncus nulla magna, id luctus mi egestas vitae. Nunc facilisis hendrerit condimentum. Sed sit amet gravida sem.',
      },
    ],
  },
};
